/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",

  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",

  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};
const stt = [
  "a",
  "b",
  "c",
  "d",
  "đ",
  "e",
  "g",
  "h",
  "i",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "x",
  "y",
];
export default function TableGDLK01c({ formData, setFieldValue }) {
  const [dataDefault, setDataDefault] = useState([
    {
      id: uuidV4(),
      stt: "I",
      content: "Tổng giá trị giao dịch phát sinh tù hoạt động kinh doanh",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "II",
      content: "Tổng giá trị giao dịch phát sinh tù hoạt động liên kết",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "1",
      content: "Hàng hóa",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "1.1",
      content: "Hàng hóa hình thành tài sản cố định",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "1.2",
      content: "Hàng hóa không hình thành tài sản cố định",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2",
      content: "Dịch vụ",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2.1",
      content: "Nghiên cứu, phát triển",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2.2",
      content: "Quảng cáo, tiếp thị",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2.3",
      content: "Quản lý kinh doanh và tư vấn, đào tạo",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2.4",
      content: "Hoạt động tài chính",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2.4.1",
      content: "Phí bản quyền và các khoản tương tự",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2.4.2",
      content: "Lãi vay",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
    {
      id: uuidV4(),
      stt: "2.5",
      content: "Dịch vụ khác",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  const handleChangeDefault = (values) => {
    const { id, name, value, type } = values;
    setDataDefault((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };

  // 1.1.abc
  const [data, setData] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  // 1.2.abc
  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable2", data2);
  }, [data2]);
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data2 });
  };
  const handleChangeDate2 = (date, id) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd2 = () => {
    setData2((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete2 = (id) => {
    setData2((prev) => prev.filter((item) => item.id !== id));
  };
  // 2.1.abc
  const [data3, setData3] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable3", data3);
  }, [data3]);
  const handleChange3 = (values) => {
    const { id, name, value, type } = values;
    setData3((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data2 });
  };
  const handleChangeDate3 = (date, id) => {
    setData3((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect3 = (id, name, value) => {
    setData3((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd3 = () => {
    setData3((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete3 = (id) => {
    setData3((prev) => prev.filter((item) => item.id !== id));
  };
  // 2.2.abc
  const [data4, setData4] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable4", data4);
  }, [data4]);
  const handleChange4 = (values) => {
    const { id, name, value, type } = values;
    setData4((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data4 });
  };
  const handleChangeDate4 = (date, id) => {
    setData4((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect4 = (id, name, value) => {
    setData4((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd4 = () => {
    setData4((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete4 = (id) => {
    setData4((prev) => prev.filter((item) => item.id !== id));
  };
  // 2.3.abc
  const [data5, setData5] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable5", data5);
  }, [data5]);
  const handleChange5 = (values) => {
    const { id, name, value, type } = values;
    setData5((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data5 });
  };
  const handleChangeDate5 = (date, id) => {
    setData5((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect5 = (id, name, value) => {
    setData5((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd5 = () => {
    setData5((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete5 = (id) => {
    setData5((prev) => prev.filter((item) => item.id !== id));
  };
  // 2.4.1.abc
  const [data6, setData6] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable6", data6);
  }, [data6]);
  const handleChange6 = (values) => {
    const { id, name, value, type } = values;
    setData6((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data6 });
  };
  const handleChangeDate6 = (date, id) => {
    setData6((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect6 = (id, name, value) => {
    setData6((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd6 = () => {
    setData6((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete6 = (id) => {
    setData6((prev) => prev.filter((item) => item.id !== id));
  };
  // 2.4.2.abc
  const [data7, setData7] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable7", data7);
  }, [data7]);
  const handleChange7 = (values) => {
    const { id, name, value, type } = values;
    setData7((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data7 });
  };
  const handleChangeDate7 = (date, id) => {
    setData7((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect7 = (id, name, value) => {
    setData7((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd7 = () => {
    setData7((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete7 = (id) => {
    setData7((prev) => prev.filter((item) => item.id !== id));
  };
  // 2.5.abc
  const [data8, setData8] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: "",
      value7: 0,
      value8: 0,
      value9: 0,
      value10: "",
      value11: 0,
      value12a: 0,
      value12b: 0,
      value12c: 0,
      value12d: 0,
      value13: false,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable8", data8);
  }, [data8]);
  const handleChange8 = (values) => {
    const { id, name, value, type } = values;
    setData8((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data8 });
  };
  const handleChangeDate8 = (date, id) => {
    setData8((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect8 = (id, name, value) => {
    setData8((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd8 = () => {
    setData8((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete8 = (id) => {
    setData8((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography variant="h6">MỤC III. THÔNG TIN XÁC ĐỊNH GIÁ GIAO DỊCH LIÊN KẾT</Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Nội dung
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center" }}>
                Giá trị bán ra cho bên liên kết
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center" }}>
                Giá trị mua vào từ bên liên kết
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Lợi nhuận tăng do xác định lại theo giá giao dịch độc lập
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center" }}>
                Thu hộ, chi hộ, phân bổ cơ sở thường trú (3)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Giao dịch thuộc phạm vi áp dụng APA (4)
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị ghi nhận của giao dịch liên kết
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định lại theo giá giao dịch độc lập
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Chênh lệch
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Phương pháp xác định giá
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị ghi nhận của giao dịch liên kết
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định lại theo giá giao dịch độc lập
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Chênh lệch
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Phương pháp xác định giá
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tổng giá trị thu hộ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tổng giá trị chi hộ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tổng giá trị doanh thu phân bổ cho cơ sở thường trú
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tổng giá trị chi phí phân bổ cho cơ sở thường trú
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5) = (4) - (3)</Td>
              <Td style={{ textAlign: "center" }}>(6)</Td>
              <Td style={{ textAlign: "center" }}>(7)</Td>
              <Td style={{ textAlign: "center" }}>(8)</Td>
              <Td style={{ textAlign: "center" }}>(9) = (8) - (7)</Td>
              <Td style={{ textAlign: "center" }}>(10)</Td>
              <Td style={{ textAlign: "center" }}>(11) = (5) + (9)</Td>
              <Td style={{ textAlign: "center" }}>(12a)</Td>
              <Td style={{ textAlign: "center" }}>(12b)</Td>
              <Td style={{ textAlign: "center" }}>(12c)</Td>
              <Td style={{ textAlign: "center" }}>(12d)</Td>
              <Td style={{ textAlign: "center" }}>(13)</Td>
            </tr>
            {/* I */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>{dataDefault[0].stt}</Td>
              <Td style={{ textAlign: "left", fontWeight: "bold" }}>{dataDefault[0].content}</Td>
              <Td>
                <InputTable
                  fontWeight={"bold"}
                  id={dataDefault[0].id}
                  name="value3"
                  value={dataDefault[0].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td>
                <InputTable
                  fontWeight={"bold"}
                  id={dataDefault[0].id}
                  name="value7"
                  value={dataDefault[0].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* II */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[1].stt}
              </Td>
              <Td style={{ textAlign: "left", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[1].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value3"
                  value={dataDefault[1].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value4"
                  value={dataDefault[1].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value5"
                  value={dataDefault[1].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value7"
                  value={dataDefault[1].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value8"
                  value={dataDefault[1].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value9"
                  value={dataDefault[1].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value11"
                  value={dataDefault[1].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value12a"
                  value={dataDefault[1].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value12b"
                  value={dataDefault[1].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value12c"
                  value={dataDefault[1].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[1].id}
                  name="value12d"
                  value={dataDefault[1].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 1 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[2].stt}
              </Td>
              <Td style={{ textAlign: "left", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[2].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value3"
                  value={dataDefault[2].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value4"
                  value={dataDefault[2].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value5"
                  value={dataDefault[2].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value7"
                  value={dataDefault[2].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value8"
                  value={dataDefault[2].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value9"
                  value={dataDefault[2].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value11"
                  value={dataDefault[2].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value12a"
                  value={dataDefault[2].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value12b"
                  value={dataDefault[2].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value12c"
                  value={dataDefault[2].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[2].id}
                  name="value12d"
                  value={dataDefault[2].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 1.1 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[3].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[3].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value3"
                  value={dataDefault[3].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value4"
                  value={dataDefault[3].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value5"
                  value={dataDefault[3].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value7"
                  value={dataDefault[3].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value8"
                  value={dataDefault[3].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[3].id}
                  name="value9"
                  value={dataDefault[3].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value11"
                  value={dataDefault[3].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value12a"
                  value={dataDefault[3].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value12b"
                  value={dataDefault[3].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value12c"
                  value={dataDefault[3].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[3].id}
                  name="value12d"
                  value={dataDefault[3].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 1.1.abc */}
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
            {/* 1.2 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[4].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[4].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value3"
                  value={dataDefault[4].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value4"
                  value={dataDefault[4].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value5"
                  value={dataDefault[4].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value7"
                  value={dataDefault[4].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value8"
                  value={dataDefault[4].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[4].id}
                  name="value9"
                  value={dataDefault[4].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value11"
                  value={dataDefault[4].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value12a"
                  value={dataDefault[4].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value12b"
                  value={dataDefault[4].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value12c"
                  value={dataDefault[4].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[4].id}
                  name="value12d"
                  value={dataDefault[4].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 1.2.abc */}
            {data2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete2(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect2(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange2}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange2({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd2}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
            {/* 2 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[5].stt}
              </Td>
              <Td style={{ textAlign: "left", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[5].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value3"
                  value={dataDefault[5].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value4"
                  value={dataDefault[5].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value5"
                  value={dataDefault[5].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value7"
                  value={dataDefault[5].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value8"
                  value={dataDefault[5].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value9"
                  value={dataDefault[5].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value11"
                  value={dataDefault[5].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value12a"
                  value={dataDefault[5].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value12b"
                  value={dataDefault[5].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value12c"
                  value={dataDefault[5].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[5].id}
                  name="value12d"
                  value={dataDefault[5].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.1 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[6].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[6].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value3"
                  value={dataDefault[6].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value4"
                  value={dataDefault[6].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value5"
                  value={dataDefault[6].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value7"
                  value={dataDefault[6].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value8"
                  value={dataDefault[6].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[6].id}
                  name="value9"
                  value={dataDefault[6].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value11"
                  value={dataDefault[6].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value12a"
                  value={dataDefault[6].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value12b"
                  value={dataDefault[6].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value12c"
                  value={dataDefault[6].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[6].id}
                  name="value12d"
                  value={dataDefault[6].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.1.abc */}
            {data3.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete3(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange3}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange3}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange3}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange3}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect3(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange3}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange3}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange3}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect3(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange3}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange3}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange3}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange3}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange3}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange3({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd3}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
            {/* 2.2 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[7].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[7].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value3"
                  value={dataDefault[7].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value4"
                  value={dataDefault[7].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value5"
                  value={dataDefault[7].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value7"
                  value={dataDefault[7].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value8"
                  value={dataDefault[7].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[7].id}
                  name="value9"
                  value={dataDefault[7].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value11"
                  value={dataDefault[7].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value12a"
                  value={dataDefault[7].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value12b"
                  value={dataDefault[7].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value12c"
                  value={dataDefault[7].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[7].id}
                  name="value12d"
                  value={dataDefault[7].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.2.abc */}
            {data4.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete4(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange4}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange4}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange4}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange4}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect4(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange4}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange4}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange4}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect4(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange4}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange4}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange4}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange4}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange4}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange4({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd4}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
            {/* 2.3 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[8].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[8].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value3"
                  value={dataDefault[8].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value4"
                  value={dataDefault[8].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value5"
                  value={dataDefault[8].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value7"
                  value={dataDefault[8].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value8"
                  value={dataDefault[8].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[8].id}
                  name="value9"
                  value={dataDefault[8].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value11"
                  value={dataDefault[8].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value12a"
                  value={dataDefault[8].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value12b"
                  value={dataDefault[8].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value12c"
                  value={dataDefault[8].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[8].id}
                  name="value12d"
                  value={dataDefault[8].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.3.abc */}
            {data5.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete5(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange5}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange5}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange5}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange5}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect5(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange5}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange5}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange5}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect5(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange5}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange5}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange5}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange5}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange5}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange5({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd5}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
            {/* 2.4 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[9].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[9].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value3"
                  value={dataDefault[9].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value4"
                  value={dataDefault[9].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value5"
                  value={dataDefault[9].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value7"
                  value={dataDefault[9].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value8"
                  value={dataDefault[9].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[9].id}
                  name="value9"
                  value={dataDefault[9].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value11"
                  value={dataDefault[9].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value12a"
                  value={dataDefault[9].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value12b"
                  value={dataDefault[9].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value12c"
                  value={dataDefault[9].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[9].id}
                  name="value12d"
                  value={dataDefault[9].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.4.1 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[10].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[10].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value3"
                  value={dataDefault[10].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value4"
                  value={dataDefault[10].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value5"
                  value={dataDefault[10].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value7"
                  value={dataDefault[10].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value8"
                  value={dataDefault[10].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[10].id}
                  name="value9"
                  value={dataDefault[10].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value11"
                  value={dataDefault[10].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value12a"
                  value={dataDefault[10].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value12b"
                  value={dataDefault[10].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value12c"
                  value={dataDefault[10].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[10].id}
                  name="value12d"
                  value={dataDefault[10].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.4.1.abc */}
            {data6.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete6(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange6}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange6}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange6}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange6}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect6(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange6}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange6}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange6}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect6(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange6}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange6}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange6}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange6}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange6}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange6({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd6}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
            {/* 2.4.2 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[11].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[11].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value3"
                  value={dataDefault[11].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value4"
                  value={dataDefault[11].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value5"
                  value={dataDefault[11].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value7"
                  value={dataDefault[11].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value8"
                  value={dataDefault[11].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[11].id}
                  name="value9"
                  value={dataDefault[11].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value11"
                  value={dataDefault[11].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value12a"
                  value={dataDefault[11].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value12b"
                  value={dataDefault[11].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value12c"
                  value={dataDefault[11].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[11].id}
                  name="value12d"
                  value={dataDefault[11].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.4.2.abc */}
            {data7.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete7(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange7}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange7}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange7}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange7}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect7(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange7}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange7}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange7}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect7(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange7}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange7}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange7}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange7}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange7}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange7({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd7}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
            {/* 2.5 */}
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                {dataDefault[12].stt}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  fontStyle: "italic",
                  background: "#ddeff3",
                }}
              >
                {dataDefault[12].content}
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value3"
                  value={dataDefault[12].value3}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value4"
                  value={dataDefault[12].value4}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value5"
                  value={dataDefault[12].value5}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value7"
                  value={dataDefault[12].value7}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value8"
                  value={dataDefault[12].value8}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={"bold"}
                  id={dataDefault[12].id}
                  name="value9"
                  value={dataDefault[12].value9}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
              <Td style={{ background: "#ddeff3" }}>
                <InputTable
                  readOnly={true}
                  readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value11"
                  value={dataDefault[12].value11}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value12a"
                  value={dataDefault[12].value12a}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value12b"
                  value={dataDefault[12].value12b}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value12c"
                  value={dataDefault[12].value12c}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td>
                <InputTable
                  // readOnly={true}
                  // readOnlyBackground={true}
                  fontWeight={400}
                  id={dataDefault[12].id}
                  name="value12d"
                  value={dataDefault[12].value12d}
                  onChange={handleChangeDefault}
                />
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }} />
            </tr>
            {/* 2.5.abc */}
            {data8.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete8(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange8}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange8}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange8}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange8}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect8(item.id, "value6", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange8}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange8}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange8}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect8(item.id, "value10", e.target.value)}
                  >
                    <option value="PP1">
                      PP1: Phương pháp so sánh giá giao dịch liên kết với giá giao dịch độc lập
                    </option>
                    <option value="PP2-1">
                      PP2-1: Phương pháp so sánh tỷ suất lợi nhuận gộp trên doanh thu (phương pháp
                      giá bán lại)
                    </option>
                    <option value="PP2-2">
                      PP2-2: Phương pháp so sánh tỷ suất lợi nhuận gộp trên giá vốn (phương pháp giá
                      vốn cộng lãi)
                    </option>
                    <option value="PP2.3">
                      PP2.3: Phương pháp so sánh tỷ suất lợi nhuận thuần
                    </option>
                    <option value="PP3">
                      PP3: Phương pháp phân bố lợi nhuận giữa các bên liên kết
                    </option>
                  </select>
                </Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange8}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12a"
                    value={item.value12a}
                    onChange={handleChange8}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12b"
                    value={item.value12b}
                    onChange={handleChange8}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12c"
                    value={item.value12c}
                    onChange={handleChange8}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value12d"
                    value={item.value12d}
                    onChange={handleChange8}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange8({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td className="toggle-button" colSpan={2} style={{ textAlign: "center" }}>
                <SoftButton variant="gradient" color="dark" onClick={handleAdd8}>
                  Thêm dòng
                </SoftButton>
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      {/* <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox> */}
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
